import { PanTopRightIcon } from './PanTopRightIcon';

/**
 * author: Simran
 * id E9886955-5257-4E95-A017-C903F5F850C2
 * name pan-top-right
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-top-right.svg
 * tags
 */
export const PanUpRightIcon = PanTopRightIcon;
export default PanUpRightIcon